import { Modal, Button, Form } from "react-bootstrap";

const ReassignModal = ({
    show,
    onHide,
    agents,
    assignedTo,
    setAssignedTo,
    onSubmit,
    onCancel,
}) => (
    <Modal show={show} onHide={onHide} backdrop="static" centered size="xl">
        <Modal.Header closeButton className="border-0">
            <Modal.Title>Re-Assign Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form.Group>
                <Form.Select
                    className="custom-input custom-input-color"
                    value={assignedTo}
                    onChange={e => setAssignedTo(Number(e.target.value))}
                >
                    {agents &&
                        agents.map(agent => (
                            <option key={agent.value} value={agent.value}>
                                {agent.label}
                            </option>
                        ))}
                </Form.Select>
            </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 mb-2 gap-3">
            <Button variant="outline-secondary px-5 py-2" onClick={onCancel}>
                Cancel
            </Button>
            <Button variant="primary px-5 py-2" onClick={onSubmit}>
                Submit
            </Button>
        </Modal.Footer>
    </Modal>
);

export default ReassignModal;
